import { render } from "./IconTicket.vue.js?vue&type=template&id=4026c3f1!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./IconTicket.vue?vue&type=template&id=4026c3f1"
const script = {}

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__